import { render, staticRenderFns } from "./tencentadsapp.vue?vue&type=template&id=0ecd2812&"
import script from "./tencentadsapp.vue?vue&type=script&lang=js&"
export * from "./tencentadsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports